
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { PickerHOC, SessionWrapper, UiWrapper, UserWrapper, View } from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { GlobalAgent } from './components/GlobalAgent/GlobalAgent';
import { DashboardContext } from './contexts/Dashboard';

export const Dashboard = PickerHOC({
	agentUser: {
		sourcePath: 'user',
		sourceWrapper: UserWrapper,
	},
})(() => {
	const { useLoading } = UiWrapper.use();
	const { agentUser } = PickerHOC.use();
	const { clearSession } = SessionWrapper.use();

	const [loading, setLoading] = useState();

	const [start, setstart] = useState(false);

	const agentRole = useMemo(() => agentUser?.roles[0]?.identifier || undefined, [agentUser]);
	const { setAgent, setIsGlobal } = useContext(DashboardContext);

	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();

	useEffect(() => {
		const startDash = async () => {
			setAgent(agentUser);
			setIsGlobal(agentRole);
			setstart(true);
		};

		startDash();
	}, [agentUser, agentRole, setAgent, setIsGlobal]);

	useEffect(() => {
		const closeSessionHandler = (ev) => {
			if (typeof ev.data !== 'object') return;
			if (!ev.data.type || !ev.data.message) return;
			if (ev.data.type !== 'logout') return;
			if (ev.data.message !== 'close-session' && ev.data.message !== 'access-denied') return;
			clearSession();
		};

		// Evento enviado desde el iframe del dashboard vida-riesgo
		window.addEventListener('message', closeSessionHandler);

		// Don't forget to remove addEventListener
		return () => window.removeEventListener('message', closeSessionHandler);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Wrapper isAgent={true}>
			<View
				dahboardFullCenterSt
				style={
					{
						// backgroundColor: 'green',
					}
				}
			>
				{start && (
					<>
						{console.log() || agentRole === 'GLOBAL_AGENT' ? (
							<GlobalAgent agentUser={agentUser} />
						) : null}
					</>
				)}
			</View>
		</Wrapper>
	);
});
